import React, { Component } from 'react';
import {Modal, Button, ListGroup} from "react-bootstrap";

class WalletModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      wallets: [],
      discovered: false,
    };
    this._announceHandler = null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      this.discoverWallets();
    }
    if (!this.props.show && prevProps.show) {
      this.cleanup();
    }
  }

  componentWillUnmount() {
    this.cleanup();
  }

  cleanup() {
    if (this._announceHandler) {
      window.removeEventListener('eip6963:announceProvider', this._announceHandler);
      this._announceHandler = null;
    }
    this.setState({ wallets: [], discovered: false });
  }

  discoverWallets() {
    const wallets = [];

    this._announceHandler = (event) => {
      // Deduplicate by uuid
      if (!wallets.find(w => w.info.uuid === event.detail.info.uuid)) {
        wallets.push(event.detail);
        this.setState({ wallets: [...wallets] });
      }
    };

    window.addEventListener('eip6963:announceProvider', this._announceHandler);
    window.dispatchEvent(new Event('eip6963:requestProvider'));

    // Give wallets a moment to respond, then mark discovery complete
    setTimeout(() => {
      this.setState({ discovered: true });
    }, 200);
  }

  handleSelect = (provider) => {
    this.props.onConnect(provider);
    this.props.onHide();
  }

  render() {
    const { show, onHide, platform } = this.props;
    const { wallets, discovered } = this.state;

    const hasEIP6963 = wallets.length > 0;
    const hasLegacy = !hasEIP6963 && typeof window !== 'undefined' && window.ethereum;

    return(
      <Modal aria-labelledby="contained-modal-title-vcenter" centered
            size="lg" show={show} onHide={onHide}>
        <Modal.Header>
          <Modal.Title className="font-display">connect wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {hasEIP6963 && (
            <ListGroup>
              {wallets.map((wallet) => (
                <ListGroup.Item
                  key={wallet.info.uuid}
                  action
                  onClick={() => this.handleSelect(wallet.provider)}
                  className="d-flex align-items-center font-display"
                >
                  {wallet.info.icon && (
                    <img
                      src={wallet.info.icon}
                      alt={wallet.info.name}
                      width={32}
                      height={32}
                      style={{marginRight: '12px'}}
                    />
                  )}
                  {wallet.info.name}
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
          {!hasEIP6963 && hasLegacy && discovered && (
            <ListGroup>
              <ListGroup.Item
                action
                onClick={() => this.handleSelect(window.ethereum)}
                className="d-flex align-items-center font-display"
              >
                <span role="img" aria-label="wallet" style={{fontSize: '24px', marginRight: '12px'}}>&#x1F50C;</span>
                Browser Wallet
              </ListGroup.Item>
            </ListGroup>
          )}
          {!hasEIP6963 && !hasLegacy && discovered && (
            <div>
              {platform.noWeb3Message}
            </div>
          )}
          {!discovered && (
            <div className="text-center font-display">
              detecting wallets...
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!hasEIP6963 && !hasLegacy && discovered && (
            <>
              <Button variant="outline-secondary btn-sm" className="font-display" href={`${platform.etherscan_link}0xA8A6CB3978e2c4EdcF5A3d0cB3400E1E5D031479`}>
                browse on Etherscan
              </Button>
              <Button variant="outline-secondary btn-sm" className="font-display" href="https://brave.com/">
                get Brave
              </Button>
              <Button variant="outline-secondary btn-sm" className="font-display" href="https://metamask.io/">
                get MetaMask
              </Button>
            </>
          )}
          <Button variant="outline-secondary btn-sm" className="font-display" onClick={onHide}>
            close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default WalletModal;
